export default __webpack_public_path__ + "static/media/COA-icon.e44a01c5.svg";